export default __webpack_public_path__ + "static/media/male-avatar.d16f33d0.png";